<template>
	<div :class="shovValidate ? 'v-textarea showError' : 'v-textarea'">
			<div :class="valid ? 'v-textareaWrapper complete' : 'v-textareaWrapper incomplete'">
				<textarea
				v-model="inputValue"
				:name='data.name'
				:text='data.text'
				:required='data.required'
				:placeholder='data.placeholder'
				@keyup="test"
				></textarea>
		</div>
	</div>
</template>

<script>
module.exports = {
	props: ['data'],

	data() {
		return {
				inputValue: '',
				name: this.data ? this.data.name : '',
				valid: false,
				shovValidate: false
		}
	},

	watch: {

	},

	methods: {
		test(){
			this.$emit('changedText', {
				name: this.name,
				value: this.inputValue
			});
			// this.valid = true;
			this.shovValidate = true;
			if(this.data.required == false){
				this.shovValidate = false;
			}

			if(this.inputValue != ''){
				this.valid = true;
			}else {
				this.valid = false;
			}
		},
		validate() {
			if(this.data.required == true){
				if(this.inputValue == ''){
					this.shovValidate = true;
				}else {
					this.valid = true;
				}
			}
			else {
				this.shovValidate = false;
				this.valid = true;
			}
		}
	},

	mounted() {
		if(this.data.required == false){
			this.$emit('changedText', {
				name: this.name,
				value: this.inputValue
			});
			this.valid = true;
			this.shovValidate = false;
		}
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.v-textarea{
	.v-textareaWrapper{
		textarea{
			box-shadow: none!important;
			border-radius: 10px;
	    border: 1px solid #b1b1b1;
	    padding: 10px;
		}
		position: relative;
		&:after {
			content: '';
			display: flex;
			position: absolute;
			top: -22px;
			right: 5px;
			font-size: 14px;
			width: 25px;
			align-items: center;
			justify-content: center;
			z-index: 1;
			@include pointer-events(none);
			opacity: 0;
			@include single-transition;
		}
	}
	&.showError{
		.incomplete {
			&:after {
				@include fa($fa-times);
				opacity: 1;
				color: red;
			}
		}
		.complete {
			&:after {
				@include fa($fa-check);
				opacity: 1;
				color: green;
			}
		}
	}
}

</style>



// WEBPACK FOOTER //
// textarea.vue?ecdb4bea